<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      <span *ngIf="importingData.action === 'Add'">Add a new price list item</span>
      <span *ngIf="importingData.action !== 'Add'">Edit price list item</span>
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>

  <ng-container *ngIf="importingData.action === 'Add'; else editBlock">
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Šifra (product code)</mat-label>
          <input name="productCode" matInput [(ngModel)]="itemData.productCode" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Bar kod (barcode)</mat-label>
          <input name="barcode" matInput [(ngModel)]="itemData.barcode" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv (product name)</mat-label>
          <input name="productName" matInput [(ngModel)]="itemData.productName" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>JM (unit)</mat-label>
          <input name="unit" matInput [(ngModel)]="itemData.unit" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>MPC (retail price)</mat-label>
          <input
            name="retailPrice"
            matInput
            type="number"
            step="0.01"
            min="0"
            [(ngModel)]="itemData.retailPrice"
            required
          />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormValid()"
          [promiseBtn]="adding"
          (click)="addNewItemFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">Add item</span>
        </button>
      </div>
    </form>
  </ng-container>

  <ng-template #editBlock>
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Šifra (product code)</mat-label>
          <input name="productCode" matInput [(ngModel)]="itemDataEdit.productCode" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Bar kod (barcode)</mat-label>
          <input name="barcode" matInput [(ngModel)]="itemDataEdit.barcode" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Naziv (product name)</mat-label>
          <input name="productName" matInput [(ngModel)]="itemDataEdit.productName" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>JM (unit)</mat-label>
          <input name="unit" matInput [(ngModel)]="itemDataEdit.unit" />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>MPC (retail price)</mat-label>
          <input
            name="retailPrice"
            matInput
            type="number"
            step="0.01"
            min="0"
            [(ngModel)]="itemDataEdit.retailPrice"
            required
          />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormDirty() || !isFormValid()"
          [promiseBtn]="adding"
          (click)="editItemFromDialog()"
        >
          <mat-icon>save</mat-icon>
          <span class="ml-8">Update item</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
